// extracted by mini-css-extract-plugin
export var footer = "_mj-5";
export var fulfillmentInput = "_mj-0";
export var shipDateInput = "_mj-1";
export var shipmentModal = "_mj-2";
export var shipmentModalContent = "_mj-3";
export var tableContainer = "_mj-4";